import { unique } from "./unique"

export const intersection = <T>(array1: T[], array2: T[]): T[] => {
  const set2 = new Set(array2)
  return unique(array1.filter((item) => set2.has(item)))
}
